import React, { useState, useEffect } from 'react'
import { Link, useParams } from  'react-router-dom'
import { Container, Row, Col, Card, CardHeader, CardFooter } from 'reactstrap'
import { ApiService } from 'services'
import Header from '../../components/Headers/Header'
import Pagination from '../../components/Pagination'
import Table from './NotificationsTable'

function List () {
  const { id: matriculate_id } = useParams()

  const [isLoading, setIsLoading] = useState(true)

  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)

  // Opciones de paginacion, filtro y orden del listado
  const [currentOptions, setCurrentOptions] = useState({
    sort: {
      field: 'id',
      dir: 1
    },
    page: 1,
    limit: 20,
    search: '',
    count: true
  })

  const fetchData = async (newOptions) => {
    // Merge de las nuevas opciones con las viejas
    const options = Object.assign({}, currentOptions, newOptions)

    setIsLoading(true)

    // Hacemos la petición
    const res = await ApiService.getAll(`matriculates/${ matriculate_id }/notifications`, options)

    // Guardamos las opciones
    setCurrentOptions(options)

    // Recuperamos algunos datos de los resultados
    const { rows, count } = res.payload
    setData(rows)
    setTotal(count)

    // Terminamos la carga
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const changePage = (page) => {
    fetchData({
      page
    })
  }

  const changeOrder = (field, dir) => {
    fetchData({
      sort: {
        field,
        dir
      }
    })
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col sm={8}>
                    <h3 className="mb-0">Lista de Notificaciones</h3>
                  </Col>
                  <Col sm={4} className="text-right">
                    <Link to='/admin/matriculates/' className="btn btn-primary">
                        Volver
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <Table id="matriculates-table" items={ data } isLoading={ isLoading } changeOrder={ changeOrder } currentOrder={ currentOptions.sort } />
              <CardFooter className="py-4">
                <Row>
                  <Col sm={6}></Col>
                  <Col sm={6} className="d-flex justify-content-center d-sm-block">
                    <Pagination page={ currentOptions.page } count={ total } onChangePage={ changePage } />
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default List
